import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-20 bg-gradient-to-b from-neutral-900 to-black text-white relative overflow-hidden" data-id="element-10">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-11">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-amber-500 rounded-full blur-3xl" data-id="element-12"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-600 rounded-full blur-3xl" data-id="element-13"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-14">
        <div className="max-w-5xl mx-auto bg-neutral-800/50 backdrop-blur-sm border border-neutral-700 rounded-3xl overflow-hidden shadow-2xl" data-id="element-15">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-16">
            {/* Product Image Side */}
            <div className="relative h-64 md:h-auto bg-neutral-900" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/cq8FVohtcnZtzchbmAqmex/ChatGPT_Image_4_ene_2026,_18_29_04.png" alt="Qué consumen los argentinos libro digital" className="w-full h-full object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-18" />
              <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-transparent to-transparent md:bg-gradient-to-r" data-id="element-19"></div>
            </div>

            {/* Content Side */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-20">
              <div className="mb-6" data-id="element-21">
                <span className="inline-block px-3 py-1 bg-amber-500/20 text-amber-400 text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-22">
                  Oferta Limitada
                </span>
                <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-23">
                  Qué consumen los argentinos
                </h2>
                <p className="text-neutral-400 text-lg" data-id="element-24">
                  y cómo ganar dinero con eso
                </p>
              </div>

              <div className="flex items-baseline gap-2 mb-8" data-id="element-25">
                <span className="text-5xl font-bold text-white" data-id="element-26">$7499</span>
                <span className="text-neutral-500 line-through text-xl" data-id="element-27">
                  $14999
                </span>
              </div>

              <ul className="space-y-3 mb-8 text-neutral-300" data-id="element-28">
                <li className="flex items-center gap-2" data-id="element-29">
                  <ZapIcon className="w-5 h-5 text-amber-500" data-id="element-30" />
                  <span data-id="element-31">Acceso inmediato al contenido digital</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-32">
                  <ShieldCheckIcon className="w-5 h-5 text-amber-500" data-id="element-33" />
                  <span data-id="element-34">Pago 100% seguro y encriptado</span>
                </li>
              </ul>

              <motion.a href="https://checkout.nexapdf.online/cart/46713658409123:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full bg-amber-500 hover:bg-amber-400 text-black font-bold text-xl py-4 px-6 rounded-xl text-center shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] transition-all duration-300 flex items-center justify-center gap-2" data-id="element-35">
                <ShoppingCartIcon className="w-6 h-6" data-id="element-36" />
                Comprar Ahora
              </motion.a>

              <p className="text-center text-neutral-500 text-sm mt-4" data-id="element-37">
                *Precio en pesos argentinos. Oferta por tiempo limitado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}